module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/caret-round-map.svg?85d162eff7f173e562cbbea27f8ccf0c";